import { DAILY_TAB, LIVE_GAME_TAB, ModeIds } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import {
  doCreateGame,
  lobbyStore,
  setBlinking,
  setTab,
  showChallengePopup,
  useLobby,
} from "../../redux/lobby";
import ChooseGameDropdown from "./ChooseGameDropdown";
import { useUser } from "../../redux/user";
import { setBlinkingDaily, useDaily } from "../../redux/daily";
import { createInvite } from "../shared/challengeController";
import { convertToNumber } from "../../util/util";
import { useState } from "react";
import LeagueCardContainer from "./infoCards/LeagueCardContainer";
import PracticeCardContainer from "./infoCards/PracticeCardContainer";
import { useWebPush } from "@/redux/webPush";
import WebPushPopup from "../daily/WebPushPopup";
import { settingsStore } from "@/redux/settings";
import { LobbyWs } from "@/services/wsOutRoutes";
import { useWsConnection } from "@/redux/wsConnection";
import { siteDataStore } from "@/redux/siteData";
import { reportRussiaClientHealth } from "@/services/clientHealth";
import { Button } from "@/components/ui/button";

function createQuickMatch() {
  const { minOpponentRating, maxOpponentRating, noGuests } =
    settingsStore.getState();

  const {
    time,
    inc,
    variant,
    modeId,
    leaguePlay,
    gamesCreated,
    filterGuestTime,
  } = lobbyStore.getState();

  const { chessPartyMode } = siteDataStore.getState();

  const game = {
    time,
    inc,
    minElo: minOpponentRating,
    maxElo: maxOpponentRating,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    ...(chessPartyMode && { isChessParty: true }),
  };

  LobbyWs.createQuickMatch(game);
  reportRussiaClientHealth("quick_match_created", {
    time,
    inc,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    isChessParty: Boolean(chessPartyMode),
  });

  let gameCreated = false;
  gamesCreated.forEach((game) => {
    if (time === game.time && inc === game.inc && variant === game.variant) {
      gameCreated = true;
    }
  });
  if (!gameCreated) {
    doCreateGame({ time, inc, variant });
  }
}

export default function CreateGame({
  isDesktop,
  showBanner = true,
  timePopover = false,
}) {
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");
  const { leaguePlay, time, inc, variant, turnLength, gamesCreated } =
    useLobby();
  const { invites } = useDaily();
  const { id, memberLoggedIn } = useUser();
  const { modeId } = useLobby();
  const [show, setShow] = useState(false);

  const [showWepPushPopup, setShowWepPushPopup] = useState(false);
  const { isSubscribed } = useWebPush();
  const { wsConnected } = useWsConnection();

  function checkIfUserDailyGameExists(challs) {
    if (!challs) return false;

    for (let i = 0; i < challs.length; i++) {
      const chall = challs[i];
      if (
        chall.userId === id &&
        chall.turnLength === convertToNumber(turnLength) &&
        chall.variantId === convertToNumber(variant)
      ) {
        return true;
      }
    }
    return false;
  }

  function checkIfLiveGameExists(challs) {
    if (!challs) return false;

    for (let i = 0; i < challs.length; i++) {
      const chall = challs[i];
      if (
        convertToNumber(chall.time) === convertToNumber(time) &&
        convertToNumber(chall.inc) === convertToNumber(inc) &&
        convertToNumber(chall.variant) === convertToNumber(variant)
      ) {
        return true;
      }
    }
    return false;
  }

  function handlePlay() {
    if (isDesktop) {
      setTab(modeId === ModeIds.DAILY ? DAILY_TAB : LIVE_GAME_TAB);
    }

    if (modeId === ModeIds.DAILY) {
      if (!memberLoggedIn) {
        return;
      }
      const gameAlreadyRequested = checkIfUserDailyGameExists(invites);
      if (gameAlreadyRequested) {
        setBlinkingDaily({ userId: id, turnLength, variant, blinking: true });
      } else {
        if (!isSubscribed) {
          setTimeout(() => {
            setShowWepPushPopup(true);
          }, 500);
        }
        createInvite(
          {
            modeOption: variant,
            timeOption: turnLength,
            leaguePlay,
          },
          invites,
        );
      }
    } else {
      const gameAlreadyRequested = checkIfLiveGameExists(gamesCreated);
      if (gameAlreadyRequested) {
        setBlinking({ time, inc, variant, blinking: true });
      } else {
        createQuickMatch();
      }
    }
  }

  return (
    <>
      {showWepPushPopup && <WebPushPopup show={setShowWepPushPopup} />}
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-col gap-3">
          {showBanner &&
            (leaguePlay ? (
              <LeagueCardContainer isDesktop={isDesktop} />
            ) : (
              <PracticeCardContainer />
            ))}

          <div className="flex flex-col rounded-xl bg-gray-200 p-3 md:p-4">
            <div className="flex flex-col">
              <ChooseGameDropdown
                setShow={setShow}
                show={show}
                popover={timePopover}
                showModeSelect={!isDesktop}
              />
              {
                <Button
                  size="full_lg"
                  className="mt-3"
                  disabled={
                    (modeId == ModeIds.DAILY && !memberLoggedIn) || !wsConnected
                  }
                  onClick={handlePlay}
                >
                  {t("Play")}
                </Button>
              }
              <Button
                variant="subtle"
                size="full_lg"
                className="mt-3"
                disabled={
                  (modeId == ModeIds.DAILY && !memberLoggedIn) || !wsConnected
                }
                onClick={() => showChallengePopup(true)}
              >
                {lobbyT("Play with a friend")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
